export const setRedirectToApp = payload => ({
    type: 'SET_REDIRECT_TO_APP',
    payload: payload
  })
  